import flyd from "flyd";
var stack = [];
var Value = (function () {
    function Value(value) {
        this.stream = flyd.stream(value);
    }
    Value.prototype.get = function () {
        var deps = stack[0];
        deps && deps.add(this.stream);
        return this.stream();
    };
    Value.prototype.set = function (value) {
        this.stream(value);
    };
    Value.prototype.update = function (fn) {
        this.set(fn(this.get()));
    };
    Value.prototype.assign = function (value) {
        this.set(Object.assign(this.get(), value));
    };
    Value.prototype.stop = function () {
        this.stream.end(true);
    };
    return Value;
}());
export { Value };
var DerivedValue = (function () {
    function DerivedValue(fn) {
        stack.push(new Set());
        var value = fn();
        var deps = stack.shift();
        var first = true;
        this.stream = flyd.combine(function () {
            if (first) {
                first = false;
                return value;
            }
            return fn();
        }, Array.from(deps));
    }
    DerivedValue.prototype.get = function () {
        var deps = stack[0];
        deps && deps.add(this.stream);
        return this.stream();
    };
    DerivedValue.prototype.stop = function () {
        this.stream.end(true);
    };
    return DerivedValue;
}());
export { DerivedValue };
var Constraint = (function () {
    function Constraint(_a) {
        var get = _a.get, set = _a.set;
        this.value = new DerivedValue(get);
        this.setter = set;
    }
    Constraint.prototype.get = function () {
        return this.value.get();
    };
    Constraint.prototype.set = function (value) {
        this.setter(value);
    };
    Constraint.prototype.update = function (fn) {
        this.set(fn(this.get()));
    };
    Constraint.prototype.stop = function () {
        this.value.stop();
    };
    return Constraint;
}());
export { Constraint };
//# sourceMappingURL=reactive.js.map


//////////////////
// WEBPACK FOOTER
// ./~/reactive-magic/reactive.js
// module id = 91
// module chunks = 0